import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_TRAILERS',
  'CREATE_TRAILER',
  'UPDATE_TRAILER',
  'UPDATE_TRAILER_STATUS',
  'SYNC_UPDATE_TRAILER'
);
